import { FC, Ref } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { RentingPlan } from '@telialt/models/src/EshopModel';
import { formatCurrencyWithoutZeroDecimals } from '@telialt/utils/src/helpers';

import { PriceBig, PriceContainer, PriceResidual } from './TopPrice.styles';

type PriceWithResidualAmountType = {
    rentingPlan: RentingPlan;
    ref: Ref<HTMLElement>;
};

export const PriceWithResidualAmount: FC<PriceWithResidualAmountType> = ({ rentingPlan, ref }) => {
    const { t } = useTranslations();

    return (
        <PriceContainer data-test={ESHOP_TEST_ID.PRICE_WITH_RESIDUAL_AMOUNT} ref={ref as Ref<HTMLDivElement>}>
            {Boolean(rentingPlan?.monthlyPrice?.formattedValue) && (
                <div>
                    <PriceBig>{formatCurrencyWithoutZeroDecimals(rentingPlan.monthlyPrice.value)}&nbsp;</PriceBig>
                    {rentingPlan.monthlyPrice.currency}/{rentingPlan.monthlyPrice.period}
                    <PriceResidual>
                        {t['eshop.product_page.renting.residual_price']} :&nbsp;
                        <b>
                            {formatCurrencyWithoutZeroDecimals(rentingPlan.residualPrice.value)}&nbsp;
                            {rentingPlan.residualPrice.currency}
                        </b>
                    </PriceResidual>
                </div>
            )}
        </PriceContainer>
    );
};
